import { languages } from '../i18n/locales.js';

export const publicPages = ['', 'about', 'photo-ideas', 'faq'];

// Public URLs are routes of the existing app. Localized HTML is only its
// pre-rendered entry document, never a separate website or application shell.
export function resolvePublicRoute(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return { page: '', locale: null };
  if (parts.length === 1 && publicPages.includes(parts[0])) return { page: parts[0], locale: null };
  const locale = languages.find(language => language.code === parts[0])?.code;
  const page = parts[1] || '';
  return locale && parts.length <= 2 && publicPages.includes(page) ? { locale, page } : null;
}
